import { BreakPoints } from '@kanda-libs/ks-design-library';
import UnsubLayoutDesktop from './Desktop';
import UnsubLayoutMobile from './Mobile';
import useUnsubscribe from './useUbsubscribe';

interface UnsubLayoutProps {
  children: React.ReactNode;
  mobileFooter?: React.ReactNode;
}

const Wrapper: React.FunctionComponent<UnsubLayoutProps> = function ({
  children,
}) {
  return (
    <div className="flex flex-col flex-1 w-full max-w-216 mx-auto">
      {children}
    </div>
  );
};

const UnsubLayout: React.FunctionComponent<UnsubLayoutProps> = function ({
  children,
  mobileFooter,
}) {
  useUnsubscribe();
  return (
    <BreakPoints
      mobile={
        <UnsubLayoutMobile footer={mobileFooter}>
          <Wrapper>{children}</Wrapper>
        </UnsubLayoutMobile>
      }
      desktop={
        <UnsubLayoutDesktop>
          <Wrapper>{children}</Wrapper>
        </UnsubLayoutDesktop>
      }
    />
  );
};

export default UnsubLayout;
